<template>
  <div>
    <div class="user_content">
      <img src="../../assets/img/trustlook-logo.png" alt="" class="logo" />
      <div class="sign">
        <span @click="jump('/login')">{{ $t('user.SignIn') }}</span>
        <span @click="jump('/register')">{{ $t('user.SignUp') }}</span>
        <span ref="lang">
          <span @click="languageStatus = !languageStatus" class="choose icon-lang"></span>
          <el-collapse-transition>
            <ul class="language_selection" v-show="languageStatus">
              <li @click="switchLang('zh')" :class="{ active: lang === 'zh' }">中文</li>
              <li @click="switchLang('en')" :class="{ active: lang === 'en' }">English</li>
            </ul>
          </el-collapse-transition>
        </span>
      </div>
      <div class="content">
        <h2 class="title">{{ $t('user.ForgotPassword') }}?</h2>
        <el-form
          :model="ruleForm"
          status-icon
          :rules="rules"
          ref="ruleForm"
          class="signup_ruleForm"
        >
          <el-form-item prop="email">
            <el-input
              type="email"
              v-model="ruleForm.email"
              autocomplete="off"
              @keyup.enter.native="getEnterCode"
              :placeholder="$t('user.Email')"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <div class="btn_sign" @click="submitForm('ruleForm')">
              <i class="el-icon-loading" v-if="loading"></i>{{ $t('message.send') }}
            </div>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import { Message } from 'element-ui'
import VueRouter from 'vue-router'

const { isNavigationFailure, NavigationFailureType } = VueRouter

export default {
  name: 'forgotPass',
  data() {
    var validateEmail = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('errMsg.emailErr1')))
      }
      if (value) {
        setTimeout(() => {
          // Updated regex to properly handle hyphens and be more standard
          var reg = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
          if (!reg.test(value)) {
            callback(new Error(this.$t('errMsg.emailErr2')))
          } else {
            callback()
          }
        }, 500)
      }
    }
    return {
      loading: false,
      languageStatus: false,
      ruleForm: {
        email: ''
      },
      rules: {
        email: [{ validator: validateEmail, trigger: ['blur', 'change'] }]
      }
    }
  },
  methods: {
    getEnterCode: function(e) {
      var keyCode = window.event ? e.keyCode : e.which
      if (keyCode == 13) {
        this.submitForm('ruleForm')
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.loading = true
          let data = {
            email: this.ruleForm.email
          }
          axios
            .post('/api/user/forget-password', data)
            .then(res => {
              this.loading = false
              Message({ type: 'success', message: this.$t('errMsg.tip2'), showClose: true })
              this.$router.push('/tip').catch(err => {
                // to hide the below error message
                if (!isNavigationFailure(err, NavigationFailureType.duplicated)) {
                  throw Error(err)
                }
              })
            })
            .catch(err => {
              this.loading = false
              Message({ type: 'error', message: this.$t('errMsg.err3'), showClose: true })
            })
        } else {
          Message({ type: 'error', message: this.$t('errMsg.err1'), showClose: true })
          return false
        }
      })
    },
    jump(url) {
      this.$router.push(url).catch(err => {
        // to hide the below error message
        if (!isNavigationFailure(err, NavigationFailureType.duplicated)) {
          throw Error(err)
        }
      })
    },
    switchLang(lang) {
      if (lang === this.$store.state.lang) return
      this.$store.commit('switchLang', lang)
      this.languageStatus = false
      Message({ type: 'success', message: this.$t('message.switchSuccessfully'), showClose: true })
      location.reload()
    }
  },
  computed: {
    lang() {
      return this.$store.state.lang
    }
  },
  mounted() {
    let _this = this
    document.addEventListener('click', e => {
      if (!!_this.$refs.lang && !!_this.$refs.lang.contains(e.target)) return
      _this.languageStatus = false
    })
  }
}
</script>
<style lang="scss" src="./user.scss" scoped></style>
<style lang="scss" scoped>
.content {
  width: 540px;
  height: 353px;
  box-sizing: border-box;
  padding: 60px 70px 0;
  background: $bg-user-color;
  @include box-shadow2;
  @include border-radius(10px);
  .title {
    font-size: 24px;
    font-family: NexaBold;
    font-weight: bold;
    color: rgba(243, 246, 254, 1);
    height: 29px;
    margin-bottom: 48px;
    text-align: center;
  }
  .signup_ruleForm {
    width: 100%;
    ::v-deep .el-form-item__label {
      color: rgba(255, 255, 255, 0.4);
      margin-left: 16px;
      font-size: 16px;
    }
    .btn_sign {
      margin-top: 50px;
    }
  }
}

@media screen and (max-width: 450px) {
  .content {
    width: 100%;
    padding: 60px 40px 0;
    background: none;
    box-shadow: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/user/forgotPass.vue